import React from 'react';

type HelperTextProps = Readonly<{
  id?: string;
  text: string;
}>;

function HelperText({ id, text }: HelperTextProps): JSX.Element {
  return (
    <span id={id} className="helper-text" aria-live="polite">
      {text}
    </span>
  );
}

export default HelperText;
